import Button from '@hotmart/space-lib/dist/components/button'
import { toastEventDispatch } from '@hotmart/space-lib-events/dist/toast'
import { ToastPosition, ToastType } from '@hotmart/space-lib-events/dist/toast/enum'
import { useState } from 'react'
import { deleteComment } from 'src/client'
import i18n from 'src/i18n'
import Modal from '../index'
import ModalHeader from '../header'
import ModalBody from '../body'
import ModalFooter from '../footer'
import { ModalRemoveCommentProps } from './types'

const RemovePost = ({
  isOpen,
  closeModal,
  newsId,
  commentId,
  setRefreshPage,
  refreshPage
}: ModalRemoveCommentProps) => {
  const [loading, setLoading] = useState(false)

  const handleDeletePost = async () => {
    try {
      setLoading(true)
      await deleteComment(newsId, commentId)
      setRefreshPage(!refreshPage)
      closeModal()
      toastEventDispatch({
        type: ToastType.SUCCESS,
        message: i18n.t('remove_comment.success_message'),
        position: ToastPosition.BOTTOM_RIGHT
      })
    } catch {
      closeModal()
      toastEventDispatch({
        type: ToastType.DANGER,
        message: i18n.t('remove_comment.error_message'),
        position: ToastPosition.BOTTOM_RIGHT
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal show={isOpen} onClose={closeModal}>
      <ModalHeader>
        <h3 className="_text-4">{i18n.t('remove_comment.title')}</h3>
      </ModalHeader>

      <ModalBody>
        <p className="_text-2 _text-gray-500">{i18n.t('remove_comment.description')}</p>
      </ModalBody>

      <ModalFooter>
        <div className="_d-flex _w-full _justify-content-end _align-items-center">
          <Button variation="tertiary" disabled={loading} loading={loading} onClick={closeModal}>
            {i18n.t('buttons.cancel')}
          </Button>

          <Button
            variation="primary"
            className="_ml-4"
            disabled={loading}
            loading={loading}
            onClick={handleDeletePost}
          >
            {i18n.t('buttons.remove')}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default RemovePost
